import React from 'react';
import { ArticleBody } from './ArticleBody';
import { CtaBox } from './CtaBox';
import { CommentsSection } from './CommentsSection';
import { useVisitorDate } from '../hooks/useVisitorDate';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/d44ceab1-ee31-4433-beab-34c039ac1888.jpg';
export function Article() {
  const publishedDate = useVisitorDate();
  return <article className="mx-auto max-w-article px-4 pb-14 pt-8 sm:px-6 sm:pt-12" data-id="element-7" data-mp="fwqz6nqobhqd">
      <p className="font-sans text-[0.7rem] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-8" data-mp="bvnkw5o9xtr9">
        Contenido patrocinado · Salud metabólica
      </p>

      <h1 className="mt-3 font-serif text-[2rem] font-bold leading-[1.15] tracking-tight text-ink sm:text-[2.6rem]" data-id="element-9" data-mp="plr38lk193bf">
        El factor que muchas mujeres +30 ignoran al comer y que podría estar detrás de sus antojos
        de la tarde
      </h1>

      <p className="mt-2 font-sans text-[0.8rem] text-ink-soft" data-id="element-10" data-mp="um56lqaovp34">
        📅 Publicado el: {publishedDate}
      </p>

      <h2 className="mt-5 font-serif text-[1.15rem] font-normal italic leading-relaxed text-ink-soft sm:text-[1.3rem]" data-id="element-11" data-mp="1hbielyt1it00">
        Cada vez más especialistas hablan de la «secuenciación de alimentos»: una forma sencilla
        de organizar tus comidas que podría ayudarte a sentir más saciedad, menos bajones de
        energía y mayor control frente a los antojos.
      </h2>

      <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 border-y border-neutral-200 py-3 font-sans text-[0.78rem] text-ink-muted" data-id="element-12" data-mp="209usfxuwcr1x">
        <span className="font-semibold text-ink" data-id="element-13" data-mp="257muvlt63vkd">Por: Redacción Salud Vital</span>
        <span aria-hidden="true" data-id="element-14" data-mp="29zech6uciqyd">|</span>
        <span data-id="element-15" data-mp="2a0fww1x94psr">Actualizado hoy</span>
        <span aria-hidden="true" data-id="element-16" data-mp="2e0zwrd97m7il">|</span>
        <span data-id="element-17" data-mp="2dzy989b0bsjz">7 min de lectura</span>
      </div>

      <figure className="mt-7" data-id="element-18" data-mp="2j0cj7ww65ckn">
        <img src={HERO_IMAGE} alt="Mujer de unos 38 años sosteniendo una taza de café en su cocina con expresión de cansancio o duda" className="w-full rounded-sm bg-neutral-200 object-cover" data-id="element-19" data-mp="2j144ads53rwo" />
        <figcaption className="mt-2 font-sans text-xs leading-relaxed text-ink-muted" data-id="element-20" data-mp="nxfsyl4t6102">
          El agotamiento de media tarde y los antojos de dulce no siempre son un problema de
          fuerza de voluntad. En muchos casos, pueden estar relacionados con la forma en que
          combinamos y ordenamos los alimentos durante el día. Foto ilustrativa.
        </figcaption>
      </figure>

      <ArticleBody data-id="element-21" data-mp="16m2uitns088w" />

      <CtaBox data-id="element-22" data-mp="16pqpzycs74q9" />

      <CommentsSection data-id="element-23" data-mp="12m2gvb8i412w" />
    </article>;
}